import React from "react";
import IconMultimedia from "../../../../svg/lexus/multimedia.svg";
import IconComfort from "../../../../svg/lexus/comfort.svg";
import IconSafety from "../../../../svg/lexus/safety.svg";
import IconInsurance from "../../../../svg/lexus/insurance.svg";
import IconPerformance from "../../../../svg/lexus/performance.svg";
import IconTransport from "../../../../svg/lexus/transport.svg";
import IconStyling from "../../../../svg/lexus/styling.svg";

// used in v1 and v2 to reduce the categories to specific icons
export const getCategoryIconType = (category?: string): string => {
    switch (category) {
        case "EXT/ExteriorStyling":
            return "star-alt"; //"Styling"
        case "EXT/ExteriorComfort":
            return "heart"; //"Comfort"
        case "EXT/ExteriorTransport":
            return "transport"; //"Transport"
        case "EXT/ExteriorProtection":
            return "insurance-alt"; //"Protection"
        case "EXT/ExteriorPerformance":
            return "consumptions"; //  "Performance"
        case "EXT/ExteriorSafety":
            return "cone"; //"Safety"
        case "INT/Multimedia":
            return "tablet"; //"Multimedia"
        case "INT/InteriorStyling":
            return "star-alt"; //"Styling"
        case "INT/InteriorComfort":
            return "heart"; //"Comfort"
        case "INT/InteriorTransport":
            return "transport"; //"Transport"
        case "INT/InteriorProtection":
            return "insurance-alt"; //"Protection"
        case "INT/InteriorPerformance":
            return "consumptions"; //  "Performance"
        case "INT/InteriorSafety":
            return "cone"; //"Safety"
        default:
            return "";
    }
};

// Used in V2 to get styled component icons
export const CategoryIconComponent = ({ category }: { category?: string }): JSX.Element | null => {
    const type = getCategoryIconType(category);
    let icon;
    switch (type) {
        case "star-alt":
            icon = <IconStyling width="16" height="16" />;
            break;
        case "heart":
            icon = <IconComfort width="16" height="16" />;
            break;
        case "transport":
            icon = <IconTransport width="16" height="16" />;
            break;
        case "insurance-alt":
            icon = <IconInsurance width="16" height="16" />;
            break;
        case "consumptions":
            icon = <IconPerformance width="16" height="16" />;
            break;
        case "cone":
            icon = <IconSafety width="16" height="16" />;
            break;
        case "tablet":
            icon = <IconMultimedia width="16" height="16" />;
            break;
        default:
            icon = null;
    }

    return icon;
};
